import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandLoader from './common/BrandLoader';

const PublicRoute: React.FC = () => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <BrandLoader fullScreen />;
  }

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
